import { createUserInteraction } from '../utils';
import { trackEvent } from 'lib/ui-analytics';

import { TRACKING_ACTION, TRACKING_INTERACTION } from '../Constants';

const { TARGETED_OFFERS } = TRACKING_INTERACTION;

const { PREFIX_CASINO } = TARGETED_OFFERS;

const interactions = {
  default: TARGETED_OFFERS.OFFER_APPLIED,
  casino: TARGETED_OFFERS.OFFER_APPLIED_CASINO,
};

const getInteraction = type =>
  type === PREFIX_CASINO ? interactions['casino'] : interactions['default'];

export const utagOfferApplied = (
  targetedOfferApplied,
  targetedOfferSelected,
) => {
  const codeApplied = targetedOfferApplied?.code;
  const codeSelected = targetedOfferSelected?.code;
  const type = targetedOfferSelected?.type;

  if (codeSelected) {
    if (codeApplied !== codeSelected) {
      const interactionType = {
        eventType: TRACKING_ACTION.INTERACTIONS,
        interaction: getInteraction(type),
      };
      const extraParams = {
        targetedOfferFlag: TARGETED_OFFERS.OFFER_FLAG,
        targetedOfferApplied: codeSelected,
      };
      const interaction = createUserInteraction(interactionType, extraParams);
      trackEvent(interaction);
    }
  }
};
